const decodeSegment = (segment) => {
  try {
    return decodeURIComponent(segment);
  } catch (err) {
    return segment;
  }
};

const getLink = (currentKey, targetKey, location) => {
  const search = location?.search || '';
  if (!targetKey) {
    return `/${search}`;
  }

  const pathname = location?.pathname || '/';
  // A profile opened in one school does not exist in another.
  if (pathname.indexOf('/profiles/') > -1) {
    return `/${targetKey}/profiles`;
  }

  const segments = pathname.split('/');
  const currentSegment = decodeSegment(segments[1] || '');
  if (currentKey && currentSegment === currentKey) {
    segments[1] = targetKey;
    return `${segments.join('/')}${search}`;
  }

  // The current address does not contain this school. Open the selected one
  // rather than leaving the address unchanged.
  return `/${targetKey}${search}`;
};

export { getLink };
